import server from "../Server";
import { ForgotPasswordPayload } from "../../../gateways";

export const ForgotPassword = async (params: ForgotPasswordPayload): Promise<boolean> => {
  await server.auth.resetPasswordForEmail(params.email, {
    redirectTo: process.env.EXPO_PUBLIC_REST_PASSWORD_URL,
  });
  return true;
};
